module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a5-2-303e317bd727e5472fa5ea8ba4831bf2.jpg";